import { forwardRef, type ComponentProps } from 'react';
import { cn } from '@/lib/utils';
import FieldLabelMobile from '@/domains/mobile-web/components/FieldLabelMobile/FieldLabelMobile';

export interface TextAreaMobileProps extends Omit<ComponentProps<'textarea'>, 'className'> {
    label?: string;
    error?: string;
    helperText?: string;
    showCount?: boolean;
    className?: string;
    textareaClassName?: string;
}

const TextAreaMobile = forwardRef<HTMLTextAreaElement, TextAreaMobileProps>(
    (
        {
            label,
            error,
            helperText,
            showCount = false,
            className,
            textareaClassName,
            id,
            name,
            required,
            rows = 4,
            maxLength,
            value,
            ...props
        },
        ref
    ) => {
        const textareaId = id ?? name;
        const count = typeof value === 'string' ? value.length : 0;

        return (
            <FieldLabelMobile
                label={label}
                htmlFor={textareaId}
                required={required}
                error={error}
                helperText={helperText}
                className={className}
            >
                <div className="relative w-full">
                    <textarea
                        ref={ref}
                        id={textareaId}
                        name={name}
                        required={required}
                        rows={rows}
                        maxLength={maxLength}
                        value={value}
                        aria-invalid={!!error}
                        className={cn('field-mobile field-mobile-textarea', error && 'field-mobile-error', textareaClassName)}
                        {...props}
                    />
                    {showCount && maxLength && (
                        <span className="caption pointer-events-none absolute bottom-2 right-3 text-text-grey">
                            {count}/{maxLength}
                        </span>
                    )}
                </div>
            </FieldLabelMobile>
        );
    }
);

TextAreaMobile.displayName = 'TextAreaMobile';

export default TextAreaMobile;
